module.exports = __webpack_public_path__ + "static/img/youtube.ec1efab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/youtube.png
// module id = 11le
// module chunks = 48